<template>
  <div>
    <container>
      <div class="info">
        <router-link to="/admin/past-run" class="back-link">
          <span class="back-arrow">&#x21A9;</span>
          <span class="back-text">Back</span>
        </router-link>
        <span class="info-separator">|</span>
        <a 
          :href="liveRunUrl" 
          class="live-run-link"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="live-icon">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none"/>
            <path d="M8.5 5.5L19 12L8.5 18.5V5.5Z" fill="currentColor"/>
          </svg>
          <span>View Live Run</span>
        </a>
      </div>
      <div style="display:flex">
        <p style="font-size: large;padding: 14px 10px 0px 0px;">Recording:</p>
        <div style="min-width: 300px;">
          <div v-if="!isRecordingReady" style="padding: 14px 0; color: #666;">
            Preparing recording audio...
          </div>
          <audio id="my-audio" v-on:ended="playEnd" controls v-if="recordingUrl && isRecordingReady">
            <source
              :src="recordingUrl"
              type="audio/mp3"
            >
          </audio>
        </div>


      <div class="race_desc">
        <span>Description</span>
        <div id="wrapper_description">
          <div >{{race.description}}</div>
        </div>
      </div>


      <div class="action-buttons-row">
        <button 
          class="refresh-btn" 
          @click="initialize()" 
          title="Refresh data"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4V10H7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M23 20V14H17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button
          id="loaddatafb"
          class="btn btn--primary load_data"
          @click="fromFireBase()"
        >Load From Archive
        </button>
        <div class="menu-dropdown">
          <button
            class="menu-dots-btn"
            @click="toggleMenu"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="5" r="1.5" fill="#999"/>
              <circle cx="10" cy="10" r="1.5" fill="#999"/>
              <circle cx="10" cy="15" r="1.5" fill="#999"/>
            </svg>
          </button>
          <div v-if="showMenu" class="menu-dropdown-content">
            <a href="javascript:void(0)" @click="showUpdateFromFirebaseModal">Update from Archive to API</a>
          </div>
        </div>
      </div>


      </div>

      <br>
      <div v-if="currentChannel" class="channelInfo">
        <div>Channel : {{channel}}</div>
        <div>{{currentChannel.id}}</div>
        <div>{{currentChannel.pwd}}</div>
        <div>{{currentChannel.desc}}</div>
      </div>
      <br>

      <div style="display:flex">
        <span id="wrapper" class="question">
          <div id="leftcolumn">{{todayQuestion}}</div>
        </span>

        <span id="wrapper" class="question">
          <div id="leftcolumn">{{race.quoteOfDay}}</div>
        </span>
      </div>
      <div style="display: flex; align-items: center; justify-content: flex-end; gap: 15px; margin-bottom: 10px;">
        <div style="display: flex; align-items: center; gap: 8px; padding: 6px 12px; background-color: #f8f9fa; border-radius: 6px; border: 1px solid #e9ecef;">
          <div class="runner-filter-wrapper">
            <input
              type="text"
              v-model="runnerIdFilter"
              placeholder="Find runner ID..."
              class="runner-filter-input"
            />
            <button
              v-if="runnerIdFilter"
              @click="clearFilter"
              class="runner-filter-clear"
              type="button"
              title="Clear filter"
            >
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <span style="color: #dee2e6; font-size: 12px;">•</span>
          <span style="font-size: 13px; color: #6c757d; font-weight: 400;">
            <span style="color: #495057; font-weight: 500;">{{ filteredRunnerList.length }}</span> runners
          </span>
          <span style="color: #dee2e6; font-size: 12px;">•</span>
          <span style="font-size: 13px; color: #6c757d; font-weight: 400;">
            {{ pageSize }} per page
          </span>
        </div>
        <toggle-button
          id="changed-font"
          @change="onToggle()"
          v-model="distanceInKm"
          :width="85"
          :height="30"
          :speed="480"
          :color="{unchecked: '#413b94', checked: '#ff5627'}"
          :labels="{checked: 'Km', unchecked: 'Miles'}"
        />
        <button
          id="downloadcsv"
          class="btn btn--primary load_data"
          @click="downloadCSV()"
        >Export as CSV
        </button>
      </div>

      <div style="position: relative; min-height: 400px;">
        <loader 
          v-if="tableLoading"
          :size="'medium'"
          :full-page="false"
          :show-quote="true"
          :centered="true"
        ></loader>
        <v-table
          v-show="!tableLoading"
          is-horizontal-resize
          :columns="columnsT"
          style="width:100%;font-size:10.5px"
          :column-cell-class-name="columnCellClass"
          :table-data="tableDataT"
          :show-vertical-border="true"
          :odd-bg-color="'#cfe2f3'"
          :title-row-height="60"
          :row-height="45"
          :border="1"
           @on-custom-comp="customCompFunc"
        ></v-table>
      </div>
       <jw-pagination
        :items="filteredRunnerList"
        @changePage="onPageChange"
        :pageSize="pageSize"
        :disableDefaultStyles="true">
       </jw-pagination>

       <lucky-live-runner :details = "detail" :show="showModal" @saved="onSaved"  @closed="onClosed"></lucky-live-runner>
       <update-from-firebase-modal 
         :show="showUpdateModal" 
         :raceId="raceId"
         :loading="updateLoading"
         @close="closeUpdateModal"
         @confirm="handleUpdateFromFirebase"
       ></update-from-firebase-modal>
       <update-from-firebase-results-modal
         :show="showResultsModal"
         :results="updateResults"
         @close="closeResultsModal"
       ></update-from-firebase-results-modal>
    </container>
  </div>
</template>
<script>
  import 'vue-easytable/libs/themes-base/index.css'
  import Container from '@/components/Container'
  import Loader from '@/components/Loader/Loader'
  import LuckyLiveRunner from './LuckyLiveRunner'
  import UpdateFromFirebaseModal from './UpdateFromFirebaseModal'
  import UpdateFromFirebaseResultsModal from './UpdateFromFirebaseResultsModal'
  import {
    VTable,
    VPagination
  } from 'vue-easytable'
  import Vue from "vue"
  import moment from 'moment'
  Vue.component(VTable.name, VTable)
  Vue.component(VPagination.name, VPagination)
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import {
    db
  } from '../../../firebase'
  import {
    sortBy,
    prop,
    groupBy,
    map,
    merge,
    find,
    propEq,
  } from 'ramda'
  import Races from '@/services/races'
  import RunnerInfo from '@/services/runnersByRace'
  import RaceQuestion from './Question'
  import LuckyLiveRunnerService from "@/services/luckyLiveRunner"
  import RunnersByRaceService from '@/services/runnersByRace'
  import JwPagination from '@/components/Forms/JwPagination'
  import axios from 'axios'
  import _ from 'lodash'
  import env from '@/config/env'

  export default {
    name: 'race-detail',
    computed: {
      ...mapGetters({
        race: 'Race/race',
        runners: 'Race/runners',
        question: 'RaceQuestion/question'
      }),

      startedDate() {
        return moment(this.race.startDate).format('YYYY/MM/DD')
      },
      trainerName() {
        if (this.race.trainer != undefined) {
          return this.race.trainer.firstName + this.race.trainer.lastName
        }
      },
      filteredRunnerList() {
        if (!this.runnerIdFilter || this.runnerIdFilter.trim() === '') {
          return this.runnerList
        }
        const filterValue = this.runnerIdFilter.trim().toLowerCase()
        return this.runnerList.filter(runner => {
          const runnerId = String(runner.id || '').toLowerCase()
          return runnerId.includes(filterValue)
        })
      },
      liveRunUrl() {
        const raceId = this.$route.params.raceId
        const origin = window.location.origin
        return `${origin}/#/admin/live-run/race/${raceId}`
      },
      recordingUrl() {
        if (!this.race || String(this.race.id) !== String(this.$route.params.raceId)) {
          return '';
        }
        if (this.race.liveClassRecordedUrl) {
          return this.race.liveClassRecordedUrl;
        }
        return this.pastRunAudioBaseUrl + 'live-' + this.$route.params.raceId + '.mp3';
      }
    },
    data: () => ({
      pastRunAudioBaseUrl: env.PAST_RUN_AUDIO_BASE_URL,
      isRecordingReady: false,
      audioFileNotFound:false,
      isPlay: false,
      distanceInKm:true,
      todayQuestion: '',
      quote: '',
      raceInfo: {},
      tableDataT: [],
      raceDate:'',
      showModal: false,
      showMenu: false,
      showUpdateModal: false,
      showResultsModal: false,
      raceId: null,
      updateLoading: false,
      tableLoading: false,
      updateResults: {
        success: false,
        updatedCount: 0,
        skippedCount: 0,
        errorCount: 0,
        errors: []
      },
      channel:"",
      channelInfo:{
        "A":{
          'id':"takada@liverunapp.com",
          'pwd':"Tokyo2020",
          'desc':"LR Channel 1"
        },
        'B':{
          'id':"tomo.takada@gmail.com",
          'pwd':"Tokyo2020",
          'desc':"LRCh2"
        },
        'C':{
          'id':"tomo.takada@gmail.com",
          'pwd':"Tokyo2020"
        }
      },
      currentChannel:'',
      detail:{
        runner:{
            firstName:'',
            lastName:''
        }
      },
      runnerList :[],
      runnerIdFilter: '',
      pageSize: 50,
      columnsT: [{
          field: "rank",
          title: 'Rank',
          width: 50,
          titleAlign: 'center',
          columnAlign: 'center',
          isFrozen: true,
          componentName:'lucky-runner-modal'
        },
        {
          field: "firstName",
          title: 'Runner Name',
          width: 95,
          titleAlign: 'center',
          columnAlign: 'center',
          formatter: function (rowData, rowIndex, pagingIndex, field) {
            return rowData.isNew ? '<span style="color:red;font-weight: bold;">' + rowData.firstName +
              '</span>' : rowData.firstName
          },
          isFrozen: true
        },
        {
          field: "id",
          title: 'ID',
          width: 55,
          titleAlign: 'center',
          columnAlign: 'center',
          componentName: 'runner-id',
          isFrozen: true
        },
        {
          field: "medal",
          title: 'Mdl',
          width: 60,
          titleAlign: 'center',
          columnAlign: 'center',
          isFrozen: true
        },
        {
          field: "memo",
          title: 'Memo',
          width: 200,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "lastName",
          title: 'Location',
          width: 120,
          titleAlign: 'center',
          columnAlign: 'center',
        },
        {
          field: "catchPhrase",
          title: 'CatchPhrase',
          width: 120,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "gender",
          title: 'Sex',
          width: 30,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "distance",
          title: 'distance/KM',
          width: 90,
          titleAlign: 'center',
          columnAlign: 'center',
        },
        {
          field: "gap",
          title: 'Gap (M)',
          width: 55,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "pace",
          title: 'Current Pace(min/km)',
          width: 80,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "totalPace",
          title: 'Total Pace (min/km)',
          width: 70,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "totalRuns",
          title: '#of Run',
          width: 55,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "totalDistance",
          title: 'Total KM',
          width: 65,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "daysSinceLastRun",
          title: 'Days since last LiveRuns',
          width: 60,
          titleAlign: 'center',
          columnAlign: 'center'
        },
        {
          field: "questionAnswer",
          title: 'Questionaire',
          width: 900,
          titleAlign: 'center',
          columnAlign: 'left',
          componentName: 'answers',
          isResize:true
        }
      ],
    }),
    methods: {
      ...mapActions({
        getRaceQuote: 'RaceQuote/getOne',
        getRace: 'Race/get',
      }),
      async initialize() {
        //get all data from API'S
        this.isRecordingReady = false;
        if(this.$route.params.raceId) {
          const AuthStr = 'Bearer ' + this.$auth.token();
          axios.post(
            `${this.$expressApi}api/races/${this.$route.params.raceId}/make-recording-public`,
            {},
            { headers: { Authorization: AuthStr } }
          ).finally(() => {
            this.isRecordingReady = true;
          });
        } else {
          this.isRecordingReady = true;
        }
        this.$store.dispatch('RaceQuestion/getOne', this.$route.params.raceId).then(() => {
          this.todayQuestion = this.question.question
        })
        this.$store.dispatch('Race/get', this.$route.params.raceId).then(() => {
          this.raceDate = this.race.startDate
          this.getRaceQuote(moment(this.race.startDate).format('YYYY-MM-DD')).then((e) => {
          this.quote = e.data.quote
          })
        })

        if(this.race.mobileChannelToPlay){
          this.getChannel(this.race.mobileChannelToPlay.trim())
        }

        var LuckyLiveRunnerInfo=[]
        await LuckyLiveRunnerService.getLuckyLiveRunnersByRaceId(this.$route.params.raceId).then(response => {
          LuckyLiveRunnerInfo=response.data
        }).catch(error => console.log("err--->>",error))

        var LuckyLiveRunners = LuckyLiveRunnerInfo && LuckyLiveRunnerInfo.content ?LuckyLiveRunnerInfo.content:[]

        // NEW: Use Express API to get all runner data in a single call
        this.tableLoading = true
        try {
          const staging = this.$route.query.staging || '0'
          const response = await RunnerInfo.getPastRunDetail(this.$route.params.raceId, staging)
          const runners = response.data || []

          // Transform Express API response to match expected format
          const finalData = runners.map((runner) => {
            var raceInfo = {}

            // Check if runner is lucky live runner
            var LuckyLiveRunnerInfo = LuckyLiveRunners.find(propEq('runnerId', runner.runnerId))
            raceInfo['isLuckyLiveRunner'] = LuckyLiveRunnerInfo !== undefined
            raceInfo['LuckyLiveRunnerInfo'] = LuckyLiveRunnerInfo || {}

            raceInfo['unsubscribed'] = false
            raceInfo['rank'] = runner.rank || runner.position
            raceInfo['firstName'] = runner.firstName
            raceInfo['id'] = runner.id || runner.runnerId
            raceInfo['lastName'] = runner.lastName
            raceInfo['gender'] = runner.gender

            // Convert distance based on unit preference
            if(this.distanceInKm) {
              raceInfo['distance'] = runner.distance || runner.distanceKm || '0.00'
              this.columnsT[8].title='distance/KM'
              this.columnsT[10].title='Current Pace(min/km)'
              this.columnsT[11].title='Total Pace (min/km)'
            } else {
              const distanceKm = parseFloat(runner.distance || runner.distanceKm || 0)
              raceInfo['distance'] = (distanceKm * 0.62137).toFixed(2)
              this.columnsT[8].title='distance/Miles'
              this.columnsT[10].title='Current Pace(min/mi)'
              this.columnsT[11].title='Total Pace (min/mi)'
            }

            raceInfo['gap'] = runner.gap || 0
            raceInfo['pace'] = runner.currentPace || '-'
            raceInfo['totalPace'] = runner.totalPace || '-'
            raceInfo['medal'] = runner.medal || 0
            raceInfo['memo'] = runner.memo || '-'
            raceInfo['totalRuns'] = runner.totalRuns || '-'
            raceInfo['catchPhrase'] = runner.catchPhrase || '-'

            // Convert total distance based on unit preference
            if(this.distanceInKm) {
              raceInfo['totalDistance'] = runner.totalDistance || '-'
              this.columnsT[13].title='Total KM'
            } else {
              if (runner.totalDistance && runner.totalDistance !== '-') {
                const totalKm = parseFloat(runner.totalDistance)
                raceInfo['totalDistance'] = (totalKm * 0.62137).toFixed(2)
              } else {
                raceInfo['totalDistance'] = '-'
              }
              this.columnsT[13].title='Total Miles'
            }

            raceInfo['daysSinceLastRun'] = runner.daysSinceLastRun || '0'
            raceInfo['questionAnswer'] = runner.questionAnswer || '-'
            raceInfo['postQuestionAnswer'] = runner.postQuestionAnswer || '-'

            return raceInfo
          })

          // Sort by rank, put null rank runners at bottom
          const sortByPositions = sortBy(prop('rank'))
          var runnerData = sortByPositions(finalData)
          var sortRunnerData = _.sortBy(runnerData, function (data) {
            return data.rank ? 0 : 1
          })
          this.runnerList = sortRunnerData

        } catch (error) {
          console.error('[RaceDetail] Error loading past run detail:', error)
          // Fallback to empty list on error
          this.runnerList = []
        } finally {
          this.tableLoading = false
        }
      },

      includeAllrunners(finalRunners, allRunners) {
        var result = allRunners.filter(function (o1) {
            return !finalRunners.some(function (o2) {
                return o1.id === o2.runner.id
            })
        })
        return result
    },
     onPageChange(pageOfItems) {
        this.tableDataT  = pageOfItems
        if(this.tableDataT.length>0){
          $('.v-table-views ').css('max-height','612px')
          $($(".v-table-body")[0]).css('max-height','550px')
          $($(".v-table-body")[1]).css('max-height','550px')
        }
      },

      clearFilter() {
        this.runnerIdFilter = ''
      },

      async onToggle(){
          if(this.$envdistanceIn === 'Km'){
            this.distanceInKm = false
            Vue.prototype.$envdistanceIn = 'Miles'
            window.localStorage.setItem('distanceIn','Miles')
            this.initialize()
          }else if(this.$envdistanceIn ==='Miles'){
            this.distanceInKm = true
            Vue.prototype.$envdistanceIn = 'Km'
            window.localStorage.setItem('distanceIn','Km')
            this.initialize()
          }
       },

      fromFireBase() {
        this.$router.push({
          name: 'past-run-firebase',
          params: {
            pastRun: true,
            raceId: this.$route.params.raceId
          }
        })
      },
      downloadCSV() {
        let csvData = []
        let tempRow = []
        this.columnsT.map((col) => {
            let val = col.title || ''
            val = val.replace('#', '')
            tempRow.push(val)
        })
        csvData.push(tempRow)
        const getValue = (value2) => {
            return value2.replace('#', '').replace(',', '').replace(/(\r\n|\n|\r)/gm, "").trim()
        }
        if(this.runnerList.length) {
            this.runnerList.map((runner, index) => {
               tempRow = []
               this.columnsT.map((col) => {
                let val2 = runner[col.field] || ''
                if(typeof val2 === 'string') {
                    val2 = getValue(val2)
                }
                let val3 = ''
                if(col.title === 'Questionaire') {
                    val3 = getValue(runner['postQuestionAnswer'] || '')
                    tempRow.push(`"${val2}\n${val3}"`)
                } else {
                    tempRow.push(val2)
                }
               })
               csvData.push(tempRow)
               tempRow = []
            })
        	let csvContent = "data:text/csv;charset=utf-8,"
        	csvData.map((infoArray, index) => {
			let dataString = infoArray.join(",")
			csvContent +=  dataString+ "\n"
		})

        var downloadLink = document.createElement("a")
            downloadLink.href = csvContent
            const fId = this.race.id
            const fDate = new Date().toISOString().split('T')[0]
            downloadLink.download = `${fId ? fId + '-' : 'race-'}${fDate ? fDate : 'new'}.csv`
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
        }
      },
      columnCellClass(rowIndex, columnName, rowData) {
        // Highlight if approaching milestone
        if (rowData.isApproachingMilestone) {
          return 'milestone-approaching'
        }

        if(rowData.unsubscribed){
                return 'gray'
        }
        if (rowData.isTotalPaceGreater && columnName === 'totalPace') {
          return 'column-cell-class-name-test'
        }

        if (columnName === 'questionAnswer') {
          return 'column-cell-class-name-test1'
        }
        if(columnName == 'firstName' && rowData.firstName !=undefined && rowData.firstName.length > 8){
          return 'column-cell-class-name-test-memo'
        }

        if (columnName == 'lastName' && rowData.lastName != null && rowData.lastName.length > 7) {
          return 'column-cell-class-name-test-memo'
        }

        if (rowData.memo != null && rowData.memo.length > 17) {
          return 'column-cell-class-name-test-memo'
        } else {
          return ""
        }


      },
      customCompFunc(params){
        params.race=this.race
        console.log("parm--",params)
        //console.log("params---",params)
        this.detail = params
        this.showModal = true
      },
       onClosed(){
        this.showModal = false
      },
      onSaved(data,index){
          this.tableDataT[index].isLuckyLiveRunner = true
          this.tableDataT[index].LuckyLiveRunnerInfo = data
          this.showModal = false
      },
      toggleMenu() {
        this.showMenu = !this.showMenu
      },
      showUpdateFromFirebaseModal() {
        this.showMenu = false
        this.showUpdateModal = true
      },
      closeUpdateModal() {
        this.showUpdateModal = false
        this.updateLoading = false
      },
      async handleUpdateFromFirebase(options) {
        this.updateLoading = true
        try {
          const axios = require('axios')
          const AuthStr = 'Bearer ' + this.$auth.token()
          const staging = this.$envStatus == 'Staging' ? '1' : '0'
          
          const response = await axios.post(
            `${this.$expressApi}api/runners/update-from-archive?staging=${staging}`,
            {
              raceId: parseInt(this.$route.params.raceId),
              overwriteExisting: options.overwriteExisting
            },
            {
              headers: { Authorization: AuthStr }
            }
          )
          
          if (response.data.success) {
            const data = response.data.data
            // Set results and show results modal
            this.updateResults = {
              success: true,
              updatedCount: data.updatedCount || 0,
              skippedCount: data.skippedCount || 0,
              errorCount: data.errorCount || 0,
              errors: data.errors || []
            }
            this.closeUpdateModal()
            this.showResultsModal = true
            // Refresh the page data
            this.initialize()
          } else {
            // Show error in results modal
            this.updateResults = {
              success: false,
              updatedCount: 0,
              skippedCount: 0,
              errorCount: 1,
              errors: [response.data.message || 'Failed to update from Firebase']
            }
            this.closeUpdateModal()
            this.showResultsModal = true
          }
        } catch (error) {
          console.error('Error updating from Firebase:', error)
          const errorMessage = (error.response && error.response.data && error.response.data.message) || error.message || 'Unknown error occurred'
          // Show error in results modal
          this.updateResults = {
            success: false,
            updatedCount: 0,
            skippedCount: 0,
            errorCount: 1,
            errors: [errorMessage]
          }
          this.closeUpdateModal()
          this.showResultsModal = true
        } finally {
          this.updateLoading = false
        }
      },
      closeResultsModal() {
        this.showResultsModal = false
        // Reset results
        this.updateResults = {
          success: false,
          updatedCount: 0,
          skippedCount: 0,
          errorCount: 0,
          errors: []
        }
      },
    //   play() {
    //     console.log("0000000")
    //     var myAudio = document.getElementById('my-audio')
    //     myAudio.load()
    //     myAudio.play()
    //     this.isPlay = true
    //   },
    //   pause() {
    //     var myAudio = document.getElementById('my-audio')
    //     myAudio.load()
    //     myAudio.pause()
    //     this.isPlay = false
    //   },
    //   playEnd(){
    //      this.isPlay = false
    //   },
    //   downloadItem(url) {
    //     axios.get(url, {
    //         responseType: 'blob'
    //       })
    //       .then(({
    //         data
    //       }) => {
    //         const blob = new Blob([data], {
    //           type: 'audio/mp3'
    //         })
    //         let link = document.createElement('a')
    //         link.href = window.URL.createObjectURL(blob)
    //         link.download = `${this.race.id}.mp3`
    //         link.click()
    //       })
    //   }

    // },

    play() {
        var myAudio = document.getElementById('my-audio')
        //myAudio.load()
        myAudio.play()
        this.isPlay = true
      },
      pause() {
        var myAudio = document.getElementById('my-audio')
        //myAudio.load()
        myAudio.pause()
        this.isPlay = false
      },
      playEnd(){
         this.isPlay = false
      },
      downloadItem() {
        var url = `${this.pastRunAudioBaseUrl}live-${this.$route.params.raceId}.mp3`
        axios.get(url, {
            responseType: 'blob'
          })
          .then(({
            data
          }) => {
            const blob = new Blob([data], {
              type: 'audio/mp3'
            })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = `${this.race.id}.mp3`
            link.click()
          })
      },
      checkAudioUrl(){
        if (!this.recordingUrl) return;
        var that = this
        $.ajax({
                url: this.recordingUrl,
                error: function()
                {
                  that.audioFileNotFound = true
                },
                success: function()
                {
                  that.audioFileNotFound = false
                }
            })
      },
      async getChannel(mobileChannelToPlay){
        switch (mobileChannelToPlay) {
            case 'https://api.spreaker.com/v2/episodes/18340960/play':
              this.channel = 'A'
              this.currentChannel = this.channelInfo.A
              break
            case 'https://api.spreaker.com/v2/episodes/20496650/play':
              this.channel = 'B'
              this.currentChannel = this.channelInfo.B
              break
            case 'https://edge.mixlr.com/channel/ygdpy':
              this.channel = 'C'
              this.currentChannel = this.channelInfo.C
              break
        }
        console.log("current>>>>",this.currentChannel)
      }
    },
    created() {
      this.raceId = parseInt(this.$route.params.raceId)
      this.$store.dispatch('Race/getRunners', this.$route.params.raceId)
      // this.checkAudioUrl() // Moved to watcher
      this.initialize()
      if(this.$envdistanceIn == 'Km'){
        this.distanceInKm = true
      }else{
        this.distanceInKm = false
      }
      
      // Close menu when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.menu-dropdown')) {
          this.showMenu = false
        }
      })
    },
    watch: {
      recordingUrl(newVal) {
        if (newVal) {
          this.checkAudioUrl();
        }
      }
    },
    components: {
      Container,
      Loader,
      LuckyLiveRunner,
      JwPagination,
      UpdateFromFirebaseModal,
      UpdateFromFirebaseResultsModal
    }
  }


  Vue.component('runner-id', {
    template: `<span>
        <a href="" @click.stop.prevent="runnerData()">{{rowData.id}}</a>&nbsp
        </span>`,
    props: {
      rowData: {
        type: Object
      },
      field: {
        type: String
      },
      index: {
        type: Number
      }
    },
    methods: {
      runnerData() {

        let route = this.$router.resolve({
          name: 'runner-data',
          params: {
            runnerId: this.rowData.id,
            raceId: this.$route.params.raceId
          }
        })
        window.open(route.href, '_blank')
      }
    },
    created() {
      //   this.id =   this.rowData.id
    }
  })
  Vue.component('answers', {
    template: `<div style = "width:890px">
                    <a href= "javascript:void(0)" @click  = isPreRead() v-bind:style="{ color: preactiveColor }">{{rowData.questionAnswer}}</a>
                    <br/>
                    <hr style ="margin-bottom: 4px;margin-top: 4px;">
                    <span >
                    <a href= "javascript:void(0)" @click  = isPostRead() v-bind:style="{ color: postactiveColor }"> {{rowData.postQuestionAnswer}}</a>
                    </span>
                  </div>`,
    data: () => ({
      //   id:null
      preactiveColor: 'black',
      postactiveColor: 'red'
    }),
    props: {
      rowData: {
        type: Object
      },
      field: {
        type: String
      },
      index: {
        type: Number
      }
    },
    methods: {
      isPreRead() {
        this.preactiveColor = '#a33ef1'
        db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/runners/${this.rowData.id}`).update({
          'preAnswerRead': true,
          'isRunnerCalled': true,
        })
      },
      isPostRead() {
        this.postactiveColor = '#a33ef1'
        db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/runners/${this.rowData.id}`).update({
          'postAnswerRead': true,
          'isRunnerCalled': true,
        })
      }
    },

    created() {
      let that = this
      let AnswersInterval = setInterval(async function () {
        let liveStatus = await db.ref(`/${that.$fbDbEntry}/${that.$route.params.raceId}/statusLive`).once(
          'value')
        if (liveStatus.val() === 'finished') {
          clearInterval(AnswersInterval)
        }
        let preAnswerRead = await db.ref(
          `/${that.$fbDbEntry}/${that.$route.params.raceId}/runners/${that.rowData.id}/preAnswerRead`).once(
          'value')
        let postAnswerRead = await db.ref(
            `/${that.$fbDbEntry}/${that.$route.params.raceId}/runners/${that.rowData.id}/postAnswerRead`)
          .once('value')
        if (preAnswerRead.val()) {
          that.preactiveColor = '#a33ef1'
        } else {
          that.preactiveColor = 'black'
        }
        if (postAnswerRead.val()) {
          that.postactiveColor = '#a33ef1'
        } else {
          that.postactiveColor = 'red'
        }
      }, 1000)
    }
  })

  Vue.component('lucky-runner-modal',{
        template:`
        <div>
            <button id="tickBtn" v-if="rowData.isLuckyLiveRunner"></button>
            <span @click.stop.prevent="openEditModal()" style="cursor:pointer">{{rowData.rank}}</span>
        </div>
           `,
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            },
        },
        methods:{
          openEditModal(){
                let params = {columeName:"luckyLiveRunner",runner:this.rowData,index:this.index}
                this.$emit('on-custom-comp',params)
            }
        },
        created() {
        }
  })

</script>

<style>
 #tickBtn {
        width: 20px;
        height: 13px;
        /* margin-top: 10px; */
        /* float: left; */
        margin-right: 2px;
        background-image: url(../../../assets/tick.png);
        background-repeat: no-repeat;
        background-color: transparent;
        border: none;
    }
</style>
<style lang="stylus" scoped>

  .info
    display flex
    flex-flow row wrap
    align-items center
    font-size 16px
    margin 0 0 15px
    gap 0

  .back-link
    display inline-flex
    align-items center
    text-decoration none
    color #0066cc
    margin-right 0
    transition color 0.2s
    line-height 1

  .back-link:hover
    color #0052a3

  .back-arrow
    display inline-block
    margin-right 4px
    line-height 1

  .back-text
    display inline-block
    line-height 1

  .info-separator
    color #ccc
    margin 0 12px
    font-size 16px
    line-height 1

  .live-run-link
    display inline-flex
    align-items center
    gap 6px
    color #6c757d
    text-decoration none
    font-size 16px
    font-weight 400
    transition color 0.2s
    margin-left 0
    line-height 1

  .live-run-link:hover
    color #495057
    text-decoration underline

  .live-run-link span
    display inline-block
    line-height 1

  .live-icon
    flex-shrink 0
    display inline-block
    line-height 0
    transform translateY(-1.5px)

  .action-buttons-row
    display flex
    align-items center
    gap 16px
    float right

  .refresh-btn
    background none
    border none
    padding 6px
    cursor pointer
    display inline-flex
    align-items center
    justify-content center
    color #666
    transition color 0.2s, transform 0.2s
    flex-shrink 0

  .refresh-btn:hover
    color #333
    transform rotate(90deg)

  .refresh-btn:active
    transform rotate(180deg)

</style>
<style>
  .question {
    border: 1px solid #66666673;
    border-radius: 20px;
    padding: 10px 15px 25px 15px;
    width: 100%;
  }

  #wrapper {
    width: 50% !important;
    padding-left: 0px !important;
    padding-bottom: 1rem !important;
    padding-right: 0 !important;
    margin-bottom: 1rem;
  }

  #wrapper_description {
    /* width: 50% !important;
    padding-left: 5px !important;
    padding-bottom: 1rem !important;
    padding-right: 5px !important;
    margin-left: 10px; */
    border: 1px solid #66666673;
    padding: 5px 10px;
    border-radius: 20px;
  }
  .race_desc{
    width:50%;
    margin-left:10px
  }
  .race_desc span {
    font-weight: 900;
    font-size: 16px;
    margin-left: 20px;
  }

  .milestone-approaching {
    background-color: #fff9c4 !important;
    font-weight: 500;
  }

  .loadData {
    font-weight: 700;
    color: #fff;
    background-color: #423799;
    padding: 0px 10px;
    /* text-transform: uppercase; */
    position: sticky;
    left: 90%;
    transform: translateX(-50%);
    border-radius: 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }

  .load_data{
    border-radius: 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }

  .menu-dropdown {
    position: relative;
    display: inline-block;
  }

  .menu-dots-btn {
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;
  }

  .menu-dots-btn:hover {
    opacity: 0.7;
  }

  .menu-dots-btn svg {
    display: block;
  }

  .menu-dropdown-content {
    display: block;
    position: absolute;
    right: 0;
    background-color: #ffffff;
    min-width: 200px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1000;
    border-radius: 4px;
    margin-top: 5px;
    border: 1px solid #ddd;
  }

  .menu-dropdown-content a {
    color: #333;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    cursor: pointer;
  }

  .menu-dropdown-content a:hover {
    background-color: #f1f1f1;
  }

  .runner-filter-wrapper {
    position: relative;
    display: inline-block;
  }

  .runner-filter-input {
    padding: 4px 28px 4px 8px;
    font-size: 13px;
    color: #495057;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    background-color: #ffffff;
    width: 150px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  .runner-filter-input::placeholder {
    color: #adb5bd;
  }

  .runner-filter-input:hover {
    border-color: #adb5bd;
  }

  .runner-filter-input:focus {
    border-color: #495057;
    box-shadow: 0 0 0 2px rgba(73, 80, 87, 0.1);
  }

  .runner-filter-clear {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c757d;
    transition: color 0.2s;
    outline: none;
  }

  .runner-filter-clear:hover {
    color: #495057;
  }

  .runner-filter-clear:active {
    color: #212529;
  }

</style>



// WEBPACK FOOTER //
// RaceDetail.vue?1124c6cc